export default __webpack_public_path__ + "static/logan-f699fb1867e6173c35554f3f9452832a.jpeg";